import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import {
  MATCH_STATUS_NOT_STARTED,
  MATCH_STATUS_PENDING_DATE,
  MATCH_STATUS_FINISHED,
  MATCH_STATUS_REVIEWED,
  MATCH_PHASE_TYPE_REGULAR_LEAGUE,
  MATCH_STATUS_HIDDEN,
} from "../utils/constants";

const getPositionColor = (position, lastPosition) => {
  if (position === 1) return "mint";
  if (position === 2 || position === 3) return "gold";
  if (position === lastPosition - 1 || position === lastPosition - 2)
    return "uv";
  if (position === lastPosition) return "red";
  return null;
};

const GroupRow = (player) => {
  const [matchesDetail, setMatchesDetail] = useState(false);
  const [showCriteria, setShowCriteria] = useState(false);
  const posColor = getPositionColor(player.position, player.lastPosition);

  if (player.username === "DESCANSA") return null;

  return (
    <Wrapper>
      <Row
        onClick={() => setMatchesDetail(!matchesDetail)}
        playerid={player.playerId}
      >
        <ColPos>
          <PosDot $color={posColor} />
          <PosClickable onClick={(e) => { e.stopPropagation(); setShowCriteria(true); }}>
            {player.position}
          </PosClickable>
        </ColPos>
        <ColPlayer>
          <PlayerLink to={`/player/${player.playerId}`} onClick={(e) => e.stopPropagation()}>
            {player.username}
          </PlayerLink>
        </ColPlayer>
        <ColStatPoints>{player.points ? player.points : 0}</ColStatPoints>
        <ColStatSecondary>{`${player.seriesWin ? player.seriesWin : 0} - ${
          player.seriesLoose ? player.seriesLoose : 0
        }`}</ColStatSecondary>
        <ColStatSecondary>{`${player.mapsWin ? player.mapsWin : 0} - ${
          player.mapsLoose ? player.mapsLoose : 0
        }`}</ColStatSecondary>
        <ColMatchHistory>
          {player.history
            ? player.history.map((match, index) => {
                if (match.phase !== MATCH_PHASE_TYPE_REGULAR_LEAGUE)
                  return null;

                let result = "hidden";
                let label = "?";

                if (
                  match.status === MATCH_STATUS_NOT_STARTED ||
                  match.status === MATCH_STATUS_PENDING_DATE
                ) {
                  result = "not-played";
                }

                if (
                  match.status === MATCH_STATUS_FINISHED ||
                  match.status === MATCH_STATUS_REVIEWED
                ) {
                  if (
                    (player.playerId === match.playerAid &&
                      match.playerAresult > match.playerBresult) ||
                    (player.playerId === match.playerBid &&
                      match.playerBresult > match.playerAresult)
                  ) {
                    result = "win";
                    label = String(
                      player.playerId === match.playerAid
                        ? match.playerAresult
                        : match.playerBresult
                    );
                  } else {
                    result = "defeat";
                    label = String(
                      player.playerId === match.playerAid
                        ? match.playerAresult
                        : match.playerBresult
                    );
                  }
                }

                if (
                  (match.playerAusername === "DESCANSA" ||
                    match.playerBusername === "DESCANSA") &&
                  match.status !== MATCH_STATUS_HIDDEN
                ) {
                  result = "rest";
                  label = "-";
                }

                return (
                  <MatchPill
                    key={`match-${match.matchId}-index`}
                    $result={result}
                  >
                    {label}
                  </MatchPill>
                );
              })
            : null}
        </ColMatchHistory>
        <AngleIcon>{matchesDetail ? <FaAngleUp /> : <FaAngleDown />}</AngleIcon>
      </Row>
      <DetailPanel $open={matchesDetail}>
        <MobileStats>
          <MobileStatRow>
            <MobileStatLabel>Series</MobileStatLabel>
            <MobileStatValue>{player.seriesWin || 0} - {player.seriesLoose || 0}</MobileStatValue>
          </MobileStatRow>
          <MobileStatRow>
            <MobileStatLabel>Mapas</MobileStatLabel>
            <MobileStatValue>{player.mapsWin || 0} - {player.mapsLoose || 0}</MobileStatValue>
          </MobileStatRow>
          <MobileStatRow>
            <MobileStatLabel>Partidas</MobileStatLabel>
            <MobileStatPills>
              {player.history
                ? player.history.map((match) => {
                    if (match.phase !== MATCH_PHASE_TYPE_REGULAR_LEAGUE) return null;
                    let result = "hidden";
                    let label = "?";
                    if (match.status === MATCH_STATUS_NOT_STARTED || match.status === MATCH_STATUS_PENDING_DATE) result = "not-played";
                    if (match.status === MATCH_STATUS_FINISHED || match.status === MATCH_STATUS_REVIEWED) {
                      if ((player.playerId === match.playerAid && match.playerAresult > match.playerBresult) ||
                          (player.playerId === match.playerBid && match.playerBresult > match.playerAresult)) {
                        result = "win";
                        label = String(player.playerId === match.playerAid ? match.playerAresult : match.playerBresult);
                      } else {
                        result = "defeat";
                        label = String(player.playerId === match.playerAid ? match.playerAresult : match.playerBresult);
                      }
                    }
                    if ((match.playerAusername === "DESCANSA" || match.playerBusername === "DESCANSA") && match.status !== MATCH_STATUS_HIDDEN) {
                      result = "rest";
                      label = "-";
                    }
                    return <MiniPill key={`mpill-${match.matchId}`} $result={result}>{label}</MiniPill>;
                  })
                : null}
            </MobileStatPills>
          </MobileStatRow>
        </MobileStats>
        {player.history
          ? player.history
              .sort((a, b) => (a.leagueDay > b.leagueDay ? 1 : -1))
              .map((match) => {
                if (match.phase !== "REGULAR_LEAGUE") return null;
                if (match.status === MATCH_STATUS_HIDDEN) return null;
                if (
                  match.playerAusername === "DESCANSA" ||
                  match.playerBusername === "DESCANSA"
                ) {
                  return (
                    <RestCard key={`matchrest-${player.playerId}-${match.matchId}`}>
                      <DayLabel>Jornada {match.leagueDay}</DayLabel>
                      <RestLabel>Descanso</RestLabel>
                    </RestCard>
                  );
                }
                return (
                  <MatchCard
                    key={`matchdetail-${player.playerId}-${match.matchId}`}
                  >
                    <Link
                      to={`/match/${match.matchId}/detail`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <MatchCardTop>
                        <DayLabel>Jornada {match.leagueDay}</DayLabel>
                        {match.matchDate ? (
                          <DateLabel>
                            {new Date(match.matchDate).toLocaleString(
                              "es-ES",
                              { timeZone: "Europe/Madrid" }
                            )}
                          </DateLabel>
                        ) : (
                          <DateLabel $pending>Pendiente fecha</DateLabel>
                        )}
                      </MatchCardTop>
                      <MatchCardBody>
                        <PlayerRow>
                          <PlayerName
                            $winner={
                              (player.playerId === match.playerAid &&
                                match.playerAresult > match.playerBresult) ||
                              (match.playerAaw === "AW" &&
                                player.playerId === match.playerAid)
                            }
                          >
                            {match.playerAusername}
                          </PlayerName>
                          {match.status === MATCH_STATUS_FINISHED ||
                          match.status === MATCH_STATUS_REVIEWED ? (
                            <ResultScore
                              $winner={
                                match.playerAresult > match.playerBresult
                              }
                            >
                              {match.playerAaw === "AW"
                                ? "AW"
                                : match.playerAresult ?? 0}
                            </ResultScore>
                          ) : null}
                        </PlayerRow>
                        <PlayerRow>
                          <PlayerName
                            $winner={
                              (player.playerId === match.playerBid &&
                                match.playerBresult > match.playerAresult) ||
                              (match.playerBaw === "AW" &&
                                player.playerId === match.playerBid)
                            }
                          >
                            {match.playerBusername}
                          </PlayerName>
                          {match.status === MATCH_STATUS_FINISHED ||
                          match.status === MATCH_STATUS_REVIEWED ? (
                            <ResultScore
                              $winner={
                                match.playerBresult > match.playerAresult
                              }
                            >
                              {match.playerBaw === "AW"
                                ? "AW"
                                : match.playerBresult ?? 0}
                            </ResultScore>
                          ) : null}
                        </PlayerRow>
                      </MatchCardBody>
                    </Link>
                  </MatchCard>
                );
              })
          : null}
      </DetailPanel>
      {showCriteria && (
        <CriteriaOverlay onClick={(e) => { e.stopPropagation(); setShowCriteria(false); }}>
          <CriteriaPopover onClick={(e) => e.stopPropagation()}>
            <CriteriaHeader>
              <span>{player.username}</span>
              <CloseBtn onClick={() => setShowCriteria(false)}>&times;</CloseBtn>
            </CriteriaHeader>
            <CriteriaBody>
              <CriteriaRow>
                <CriteriaLabel>Posici&oacute;n</CriteriaLabel>
                <CriteriaValue>#{player.position}{player.lastPosition ? ` / ${player.lastPosition}` : ''}</CriteriaValue>
              </CriteriaRow>
              <CriteriaRow>
                <CriteriaLabel>Puntos</CriteriaLabel>
                <CriteriaValue>{player.points || 0}{player.decidedBy === 1 ? ' \u2190' : ''}</CriteriaValue>
              </CriteriaRow>
              <CriteriaRow>
                <CriteriaLabel>Admin Lose</CriteriaLabel>
                <CriteriaValue>{player.alCriteria || 0}{player.decidedBy === 2 ? ' \u2190' : ''}</CriteriaValue>
              </CriteriaRow>
              <CriteriaRow>
                <CriteriaLabel>Diferencia de series</CriteriaLabel>
                <CriteriaValue>{(player.seriesWin || 0) - (player.seriesLoose || 0)}{player.decidedBy === 3 ? ' \u2190' : ''}</CriteriaValue>
              </CriteriaRow>
              <CriteriaRow>
                <CriteriaLabel>Series ganadas</CriteriaLabel>
                <CriteriaValue>{player.seriesWin || 0}{player.decidedBy === 4 ? ' \u2190' : ''}</CriteriaValue>
              </CriteriaRow>
              {player.decidedBy === 5 && (
                <CriteriaRow>
                  <CriteriaLabel>Duelo directo</CriteriaLabel>
                  <CriteriaValue>{player.decidedByDetail || 'N/A'}</CriteriaValue>
                </CriteriaRow>
              )}
              {player.decidedByName && (
                <DecidedByBanner>
                  <strong>Decidido por:</strong> {player.decidedByName}<br/>
                  <small>{player.decidedByDetail}</small>
                </DecidedByBanner>
              )}
              {player.position === 1 && (
                <DecidedByBanner>Lidera la clasificaci&oacute;n</DecidedByBanner>
              )}
            </CriteriaBody>
          </CriteriaPopover>
        </CriteriaOverlay>
      )}
      <RowDivider />
    </Wrapper>
  );
};

const MatchCard = styled.div`
  width: 14rem;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  overflow: hidden;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: rgba(255, 255, 255, 0.12);
  }
`;

const MatchCardTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 0.6rem;
  background: rgba(255, 255, 255, 0.02);
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
`;

const DayLabel = styled.span`
  font-family: var(--v-font-mono);
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--v-gold);
`;

const DateLabel = styled.span`
  font-family: var(--v-font-mono);
  font-size: 8px;
  color: ${({ $pending }) =>
    $pending ? "var(--v-fg-muted)" : "var(--v-fg-muted)"};
  opacity: ${({ $pending }) => ($pending ? "0.5" : "0.7")};
  font-style: ${({ $pending }) => ($pending ? "italic" : "normal")};
`;

const MatchCardBody = styled.div`
  padding: 0.5rem 0.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

const PlayerRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PlayerName = styled.span`
  font-family: var(--v-font-body);
  font-size: 12px;
  font-weight: ${({ $winner }) => ($winner ? "600" : "400")};
  color: ${({ $winner }) =>
    $winner ? "var(--v-mint)" : "var(--v-fg)"};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 9rem;
`;

const ResultScore = styled.span`
  font-family: var(--v-font-mono);
  font-size: 12px;
  font-weight: 700;
  color: ${({ $winner }) =>
    $winner ? "var(--v-mint)" : "var(--v-fg-muted)"};
`;

const RestCard = styled.div`
  width: 14rem;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  padding: 0.6rem 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const RestLabel = styled.span`
  font-family: var(--v-font-mono);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--v-fg-muted);
  font-style: italic;
`;

const Wrapper = styled.div``;

const Row = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  gap: 0.5rem;
  cursor: pointer;
  border-radius: 12px;
  transition: background 0.2s ease;

  @media (max-width: 800px) {
    padding: 0.5rem 0;
    gap: 0.35rem;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.03);
  }
`;

const ColPos = styled.div`
  width: 2.5rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-family: var(--v-font-mono);
  font-size: 13px;
  color: var(--v-fg);
`;

const PosDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ $color }) =>
    $color === "mint"
      ? "var(--v-mint)"
      : $color === "gold"
      ? "var(--v-gold)"
      : $color === "uv"
      ? "var(--v-uv)"
      : $color === "red"
      ? "#ff3b3b"
      : "transparent"};
`;

const ColPlayer = styled.div`
  flex: 1;
  min-width: 0;
  font-family: var(--v-font-body);
  font-size: 14px;
  font-weight: 500;
  color: var(--v-fg);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const PlayerLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  transition: color 0.15s ease;

  &:hover {
    color: #3860be;
  }
`;

const ColStat = styled.div`
  width: 5rem;
  flex-shrink: 0;
  text-align: center;
  font-family: var(--v-font-mono);
  font-size: 13px;
  color: var(--v-fg-muted);
`;

const ColStatSecondary = styled(ColStat)`
  @media (max-width: 800px) {
    display: none;
  }
`;

const ColStatPoints = styled(ColStat)`
  @media (max-width: 800px) {
    width: 2.5rem;
  }
`;

const ColMatchHistory = styled.div`
  width: 14rem;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  gap: 3px;

  @media (max-width: 800px) {
    display: none;
  }
`;

const MatchPill = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  background: ${({ $result }) =>
    $result === "win"
      ? "var(--v-mint)"
      : $result === "defeat"
      ? "var(--v-uv)"
      : $result === "rest"
      ? "rgba(255,255,255,0.08)"
      : $result === "not-played"
      ? "rgba(255,255,255,0.04)"
      : "transparent"};
  color: ${({ $result }) =>
    $result === "win"
      ? "#000"
      : $result === "defeat"
      ? "#fff"
      : "var(--v-fg-muted)"};
  border: ${({ $result }) =>
    $result === "not-played" || $result === "hidden"
      ? "1px solid rgba(255,255,255,0.08)"
      : "none"};
`;

const MobileStats = styled.div`
  display: none;

  @media (max-width: 800px) {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    padding: 0.5rem 0.75rem;
    background: rgba(255, 255, 255, 0.02);
    border-radius: 10px;
    margin-bottom: 0.5rem;
  }
`;

const MobileStatRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const MobileStatLabel = styled.span`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--v-secondary);
`;

const MobileStatValue = styled.span`
  font-family: var(--v-font-mono);
  font-size: 12px;
  font-weight: 600;
  color: var(--v-fg);
`;

const MobileStatPills = styled.div`
  display: flex;
  gap: 3px;
`;

const MiniPill = styled.div`
  width: 1.4rem;
  height: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  font-family: var(--v-font-mono);
  font-size: 9px;
  font-weight: 600;
  background: ${({ $result }) =>
    $result === "win" ? "var(--v-mint)"
    : $result === "defeat" ? "var(--v-uv)"
    : $result === "rest" ? "rgba(255,255,255,0.08)"
    : $result === "not-played" ? "rgba(255,255,255,0.04)"
    : "transparent"};
  color: ${({ $result }) =>
    $result === "win" ? "#000"
    : $result === "defeat" ? "#fff"
    : "var(--v-fg-muted)"};
  border: ${({ $result }) =>
    $result === "not-played" || $result === "hidden" ? "1px solid rgba(255,255,255,0.08)" : "none"};
`;

const AngleIcon = styled.div`
  width: 1.5rem;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  color: var(--v-fg-muted);
  font-size: 11px;
`;

const DetailPanel = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: ${({ $open }) => ($open ? "0.75rem" : "0 0.75rem")};
  max-height: ${({ $open }) => ($open ? "2000px" : "0")};
  opacity: ${({ $open }) => ($open ? "1" : "0")};
  overflow: ${({ $open }) => ($open ? "visible" : "hidden")};
  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
  background: rgba(255, 255, 255, 0.015);
  border-radius: 12px;
  margin: ${({ $open }) => ($open ? "0.25rem 0 0.5rem" : "0")};
`;

const RowDivider = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.03);
  margin: 0 0.5rem;
`;

const PosClickable = styled.span`
  cursor: pointer;
  transition: color 0.15s ease;

  &:hover {
    color: var(--v-mint, #3cffd0);
  }
`;

const CriteriaOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
`;

const CriteriaPopover = styled.div`
  background: #131313;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  width: 280px;
  max-width: 90vw;
  overflow: hidden;
`;

const CriteriaHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: #2d2d2d;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  font-family: var(--v-font-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #3cffd0;
`;

const CloseBtn = styled.button`
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #949494;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: all 0.15s ease;

  &:hover {
    color: #ffffff;
    border-color: #ffffff;
    background: rgba(255, 255, 255, 0.08);
  }
`;

const CriteriaBody = styled.div`
  padding: 0.75rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

const CriteriaRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);

  &:last-of-type {
    border-bottom: none;
  }
`;

const CriteriaLabel = styled.span`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1.1px;
  text-transform: uppercase;
  color: #949494;
`;

const CriteriaValue = styled.span`
  font-family: var(--v-font-body);
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
`;

const DecidedByBanner = styled.div`
  margin-top: 0.5rem;
  padding: 0.5rem 0.6rem;
  background: rgba(60, 255, 208, 0.08);
  border: 1px solid rgba(60, 255, 208, 0.2);
  border-radius: 12px;
  font-family: var(--v-font-mono);
  font-size: 10px;
  letter-spacing: 0.5px;
  color: #3cffd0;
  line-height: 1.5;

  small {
    opacity: 0.7;
    font-size: 9px;
  }
`;

export default GroupRow;
